import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";

const valueChainsChartFunc = (divRef, ndx) => {
    const dimension = ndx.dimension((d) => d.valueChain);

  const selectChart = dc.selectMenu(divRef);
  selectChart
    .dimension(dimension)
    .group(dimension.group().reduceCount((d) => d.c100))
    .title(function (d) {
      return d.key;
    })
    .on("filtered", function (chart, filter) {
      var sel = chart.filterPrinter()(chart.filters());
      window.IVALUECHAINS= sel
      // console.log("selected filters are:" + sel);
    })
    .controlsUseVisibility(true);

  return selectChart;
};

export const ValueChainsChart = (props) => (
  <ChartTemplate
        chartFunction={valueChainsChartFunc}
    // title="Gender of Financing Recipient"
    name="Select Value Chain"
  />
);
